import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';

import { Sidebar } from 'primereact/sidebar';
import { Chip } from 'primereact/chip';
import { Button } from 'primereact/button';

import ModalComodin from '@components/Email/Form/ModalComodin';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Avatar } from 'primereact/avatar';

import { SET_VALUES_EMAIL } from '@constants/actionType';
import { IconsEmails } from '@constants/general';


import { getValueLanguageObj } from '@utils/general'

import store from '@store';

import './style.scss';

// import prueba from '@utils/tinymce/tinymce.min.js'

class SideBarKeys extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModalComodin: {
        isVisible: false,
        title: '',
        description: '',
        value: '',
        descriptionsValue: null,
        label: '',
        continueAction: null,
      },
    };
    this.utilsOptions = [
      {
        id: 1,
        name: 'Btn Iniciar proceso',
        img: '/assets/img/btn-plantilla-email.png',
        action: () => this.copyToClipboarUtil(1),
      },
      {
        id: 2,
        name: 'Link',
        img: '/assets/img/link-plantilla-email.png',
        action: () => this.copyToClipboarUtil(2),
      }
    ]
  }

  copyToClipboard = (copy) => {
    const { onhide } = this.props
    navigator.clipboard.writeText(copy)
    onhide(false)
  }

  copyToClipboarUtil = (utilInd) => {
    const { onhide } = this.props
    let textCopy = ''
    switch (utilInd) {
      case 1:
        textCopy = '<p style="text-align: center;"><a href="${enlacePortal}"><img src="https://www.complianceamx.com/img/email/btn-iniciar.png" width="220" height="40"/></a></p>'
        break;
      case 2:
        textCopy = `<a href="$enlacePortal" style="font-family: 'Roboto', Helvetica, Arial, sans-serif; font-size: 16px; font-weight: 400; color: #29B6F1; text-decoration: underline;">haz clic aqu&iacute;</a>`
        break;
      default:
        break;
    }
    navigator.clipboard.writeText(textCopy)
    onhide(false)
  }

  deleteKey = async (value) => {
    const { comodines } = this.props
    const removeComodin = comodines.filter(item => item.comodin !== value.comodin)
    await store.dispatch({
      type: SET_VALUES_EMAIL,
      payload: {
        comodines: removeComodin,
      }
    });

  }

  onAddKey = () => {
    const { t } = this.props;

    this.setState({
      showModalComodin: {
        isVisible: true,
        value: '',
        descriptionsValue: null,
        continueAction: ({comodin, descripcion}) => this.addKey(comodin, descripcion),
        isAdd: true
      },
    });
  }

  addKey = async (newValue, descripcion) => {
    const { comodines } = this.props
    const newComodin = [...comodines]

    newComodin.push({comodin: newValue, descripcion})

    await store.dispatch({
      type: SET_VALUES_EMAIL,
      payload: {
        comodines: newComodin,
      }
    });
  }

  onEditKey = (oldValue, index) => {
    const { t } = this.props;
    this.setState({
      showModalComodin: {
        isVisible: true,
        description: t('*Recuerda editar la variable en la plantilla despues de guardar.'),
        value: oldValue.comodin.substring(1),
        descriptionsValue: oldValue.descripcion,
        continueAction: ({comodin, descripcion}) => this.editKey(comodin, oldValue.comodin, descripcion, index),
        index
      },
    });
  }

  editKey = async (newValue, oldValue, descripcion, index) => {
    const { comodines } = this.props


    const editComodin = [...comodines]
    editComodin[index] = {
      comodin: newValue,
      descripcion,
    }

    await store.dispatch({
      type: SET_VALUES_EMAIL,
      payload: {
        comodines: editComodin,
      }
    });
  }

  onHideModalComodin = () => {
    this.setState({
      showModalComodin: {
        isVisible: false,
      },
    });
  };

  render() {
    const {
      visible,
      onhide,
      comodines,
      isFullAdmin,
      t,
      onIconSelect
    } = this.props

    const {
      showModalComodin
     } = this.state


    const renderIcons = () => IconsEmails.map(item => (
        <div
          className='p-col-3 boder-avatar cursor-pointer'
          onClick={() => onIconSelect(item)}
          key={item.icon}
        >
          <Avatar image={item.url} className={`mr-2 ${item.extraClass}`} size="xlarge" shape="circle" />
        </div>
      ))

    const renderKeys = () =>
      (comodines || []).map((item, index) => (
          <div className="p-col" key={item.comodin}>
            <Chip
              removable
              template={
                <>
                  <Button
                    type="button"
                    label={item.comodin}
                    className='p-button-raised p-button-secondary p-button-text btn-text-chip p-m-1 p-text-bold'
                    onClick={() => this.copyToClipboard(item.comodin)}
                    tooltip={getValueLanguageObj(item.descripcion)}
                    tooltipOptions={{ position: 'top' }}
                  />
                  {isFullAdmin && (
                    <>
                      <span
                        className="p-chip-remove-icon pi pi-pencil"
                        onClick={() => this.onEditKey(item, index)}
                      />
                      <span
                        className="p-chip-remove-icon pi pi-times-circle"
                        onClick={() => this.deleteKey(item)}
                      />
                    </>
                  )}
                </>
              }
            />
          </div>
        ));

    const renderUtils = () => this.utilsOptions.map(item => (
      <div className="p-col-12 p-text-center effect-zoom-plus-contenedor border-bottom-ligth" key={item.name}>
        <img
          className="effect-zoom-plus-small cursor-pointer"
          alt="btn"
          src={item.img}
          onClick={() => item.action()}
        />
      </div>
    ))

    return (
      <div>
        <Sidebar
          visible={visible}
          onHide={() => onhide(false)}
          dismissable={false}
          position="right"
          className="keys-sidebar"
        >
          <div className="p-fluid p-grid p-mb-4">
          <div className='p-col-12 p-pt-4'>
            <Accordion multiple>
              <AccordionTab header="Iconos">
                <p>
                  {t('Listado de íconos para plantillas. Solo haz clic en el ícono y automáticamente se insertará en la plantilla.')}
                </p>
                <div className='p-grid icons-gap'>
                  {renderIcons()}
                </div>
              </AccordionTab>

              <AccordionTab header={t('Comodines')}>
                <div className="p-col-12">
                  <h5>{t('Comodines')}</h5>
                  <p>
                    {t('Son etiquetas fijas que comienzan por un signo "$" disponibles para esta plantilla; se reemplazan al momento del envío de un correo. Pueden representar el nombre, alguna fecha, folio, etc...')}
                  </p>
                  <small>
                  <li>{t('Clic en la etiqueta para copiar.')}</li>
                  <li>{t('Ctrl + V | Cmd + V en la plantilla para pegar')}</li>
                  </small>
                </div>
                {renderKeys()}
                { isFullAdmin && (
                  <div className="p-col">
                    <Chip
                      template={
                        <>
                          <span
                            className="p-chip-remove-icon pi pi-plus-circle p-m-1"
                            onClick={() => this.onAddKey()}
                          />

                        </>
                      }
                    />
                  </div>
                )}
              </AccordionTab>
              { isFullAdmin && (
                <AccordionTab header={t('Utilerias')}>
                  <div className="p-col-12 p-mt-4">
                    <h5>{t('Utilerias')}</h5>
                    <p>
                      {t('Son elementos predefinidos que ejecutan una acción en particular. Puedes agregarlos a tu contenido donde desees, para ello realiza las siguientes acciones:')}
                      <li className='p-mt-4'>{t('Clic en elemento deseado')}</li>
                      <li>{t('Dirigete a Tools > Soruce code')}</li>
                      <li>{t('Ctrl + V | Cmd + V en el código para pegar')}</li>
                    </p>
                  </div>
                  <div className="p-col-12 border-bottom-ligth"/>
                  {renderUtils()}
                  <small className="p-col-12">
                    {t('* Se requieren conocimientos básicos en HTML (en caso de duda, consulta con tu administrador)')}
                  </small>
                </AccordionTab>
              )}
          </Accordion>
          </div>
          </div>
        </Sidebar>
        { showModalComodin.isVisible && (
          <ModalComodin
            display={showModalComodin.isVisible}
            title={showModalComodin.title}
            description={showModalComodin.description}
            value={showModalComodin.value}
            descriptionsValue={showModalComodin.descriptionsValue}
            label={showModalComodin.label}
            onHidden={() => this.onHideModalComodin()}
            onContinueAction={showModalComodin.continueAction}
            allComodines={comodines}
            isAdd={showModalComodin.isAdd}
            index={showModalComodin.index}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isFullAdmin: state.settings.isFullAdmin,
  comodines: state.email.comodines
});

const mapDispatchToProps = {
};


export default withRouter(compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(SideBarKeys));
